module.exports = __webpack_public_path__ + "img/Oracle_closed.68d979eb.png";